// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iz_a bii_ss","PhotoTitleEditForm__cancelBtn":"iz_b bii_sw bii_sv"};